var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-delete": false,
              "show-save": false,
              "show-cancel": false,
              "show-new": false,
              "show-debtor-statement": true,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c(
            "div",
            { staticClass: "columns is-gapless" },
            [
              _c(
                "div",
                { staticClass: "column is-narrow" },
                [
                  _c("debtor-list-list-side-menu", {
                    on: { filter: _vm.filterList, reset: _vm.resetList },
                    model: {
                      value: _vm.filter,
                      callback: function ($$v) {
                        _vm.filter = $$v
                      },
                      expression: "filter",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "tile is-parent" }, [
                  _c(
                    "article",
                    { staticClass: "tile is-child box" },
                    [
                      _c("subtitle-totals", {
                        attrs: {
                          labels: ["Total Balance", "Total Inv. Incl. GST"],
                          totals: [_vm.sumBalance, _vm.sumTotalIncGst],
                          shows: [true, true],
                        },
                      }),
                      _c(
                        "bulma-table",
                        {
                          staticClass:
                            "table is-bordered is-striped is-narrow is-fullwidth",
                          attrs: {
                            columns: _vm.columns,
                            "page-index": _vm.filter.pageIndex,
                            "page-size": _vm.filter.pageSize,
                            "total-rows": _vm.totalRows,
                            "is-loading": _vm.isTableLoading,
                            "sort-column": _vm.filter.sortColumn,
                            "sort-order": _vm.filter.sortOrder,
                          },
                          on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                        },
                        [
                          _vm._l(_vm.entitySummaries, function (entity, index) {
                            return _c(
                              "tr",
                              {
                                key: entity.invoiceId,
                                class: {
                                  "is-selected": _vm.selectedRow === index,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.highlightSelected(index, $event)
                                  },
                                },
                              },
                              [
                                _c("td", [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.gotoViewDetails(
                                            entity.invoiceType,
                                            entity.invoiceId,
                                            entity.quoteId,
                                            entity.isAssessmentEnabled
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(entity.invoiceRef))]
                                  ),
                                ]),
                                _c("td", [_vm._v(_vm._s(entity.customerName))]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatDateTimezone(
                                        entity.invoiceDate,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]),
                                _c("td", { staticClass: "has-text-right" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatNumber(
                                        entity.balance,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]),
                                _c("td", { staticClass: "has-text-right" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatNumber(
                                        entity.totalExGst,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]),
                                _c("td", { staticClass: "has-text-right" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatNumber(
                                        entity.gst,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]),
                                _c("td", { staticClass: "has-text-right" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$filters.formatNumber(
                                        entity.totalIncGst,
                                        _vm.$userInfo.locale
                                      )
                                    )
                                  ),
                                ]),
                                _c("td", [_vm._v(_vm._s(entity.quoteNo))]),
                                _c("td", { staticClass: "has-text-centered" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "icon",
                                      class: [
                                        entity.exported
                                          ? "has-text-success"
                                          : "has-text-danger",
                                      ],
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "mdi mdi-24px",
                                        class: [
                                          entity.exported ? "mdi-check" : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("td", { staticClass: "has-text-centered" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "button is-primary is-small is-inverted tooltip is-tooltip-topright",
                                      attrs: {
                                        "data-tooltip": "Click to view",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.gotoViewDetails(
                                            entity.invoiceType,
                                            entity.invoiceId,
                                            entity.quoteId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "icon is-medium" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-file-document mdi-24px",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          }),
                          _c("template", { slot: "empty" }, [
                            _c("section", { staticClass: "section" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "content has-text-grey has-text-centered",
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { icon: "icon is-large" } },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "mdi mdi-48px mdi-emoticon-sad",
                                      }),
                                    ]
                                  ),
                                  _c("p", [_vm._v("Nothing")]),
                                ]
                              ),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm.isPrintStatementModalActive
                ? _c("debtor-list-print-statement-modal", {
                    attrs: { active: _vm.isPrintStatementModalActive },
                    on: {
                      "update:active": function ($event) {
                        _vm.isPrintStatementModalActive = $event
                      },
                      close: _vm.closePrintStatememtModal,
                    },
                    model: {
                      value: _vm.entitySummaries,
                      callback: function ($$v) {
                        _vm.entitySummaries = $$v
                      },
                      expression: "entitySummaries",
                    },
                  })
                : _vm._e(),
              _vm.isLoadAdvPaymentModalActive
                ? _c(
                    "advance-receipt-modal",
                    {
                      attrs: {
                        active: _vm.isLoadAdvPaymentModalActive,
                        "show-amount": false,
                        "show-icon": false,
                      },
                      on: {
                        "update:active": function ($event) {
                          _vm.isLoadAdvPaymentModalActive = $event
                        },
                        close: function ($event) {
                          return _vm.closeModal()
                        },
                      },
                    },
                    [
                      _c(
                        "p",
                        { attrs: { slot: "text-title" }, slot: "text-title" },
                        [_vm._v("Advance Receipt Entry")]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }